import { oneOf, node } from 'prop-types';
import tw from 'twin.macro';

const SEVERITY = {
  info: tw`border-gray-400 bg-gray-200`,
  error: tw`border-error-dark bg-error-light`,
  success: tw`border-success-dark bg-success-light`,
  warning: tw`border-warning-dark bg-warning-light`,
};

const Alert = ({ children, severity = 'info' }) => (
  <div
    tw="border-t-4 px-4 py-3"
    data-severity={severity}
    css={SEVERITY[severity]}
    role="alert"
  >
    {children}
  </div>
);

Alert.propTypes = {
  severity: oneOf(['error', 'info', 'success', 'warning']),
  children: node,
};

export default Alert;
